// Category-based grouping for License Modal
export type OfferingCategory = 'professor-led' | 'on-demand' | 'leadership-coaching';

// All offering categories - used for iteration
export const ALL_OFFERING_CATEGORIES: OfferingCategory[] = [
  'professor-led',
  'on-demand',
  'leadership-coaching',
];

export interface CategoryItem {
  category: OfferingCategory;
  label: string;
  programCount: number;
  unlicensedCount: number;
  isLicensed: boolean;
}

export interface CategoryTrackerData {
  categories: CategoryItem[];
  totalPrograms: number;
  totalUnlicensed: number;
  hasUnlicensedPrograms: boolean;
}
